import {ModuleComponent} from "../../js/module-component";

/**
 * "Así de simple" (SEION) — línea de tiempo de 5 pasos.
 *  - Autoavanza en bucle con un único setTimeout que se reprograma.
 *  - Clic en un paso lo fija y reinicia el temporizador.
 *  - El ratón sobre el módulo pausa el temporizador, la barra y el latido.
 *
 * Del handoff: los estados van por clases (is-done / is-active) sobre el botón,
 * nunca por estilos inline calculados — así el navegador reemplaza el
 * `background` completo y el gradiente del paso anterior no se queda pegado.
 * La barra de progreso se reinicia relanzando la animación CSS, nunca desde un
 * contador en el estado.
 */
export class ModAgentsNine extends ModuleComponent{

    ready(){
        super.ready();
        this.el = this.$root.get(0);
        if(!this.el) return;

        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        const dwell = parseInt(this.el.dataset.dwell || "", 10);
        this.dwell = Math.min(10000, Math.max(2000, isNaN(dwell) ? 4200 : dwell));

        this.root = this.el.querySelector(".js-root");
        this.steps = Array.from(this.el.querySelectorAll(".js-step"));
        if(this.steps.length < 2) return;

        this.active = 0;
        this.paused = false;

        this.steps.forEach((step) => {
            step.addEventListener("click", () => this.pick(Number(step.dataset.index || 0)));
        });

        if(this.root){
            this.onEnter = () => {
                clearTimeout(this.timer);
                this.paused = true;
                this.root.classList.add("is-paused");
                this.setBarState("paused");
            };
            this.onLeave = () => {
                this.paused = false;
                this.root.classList.remove("is-paused");
                this.setBarState("running");
                this.schedule();
            };
            this.root.addEventListener("pointerenter", this.onEnter);
            this.root.addEventListener("pointerleave", this.onLeave);
        }

        this.updateSteps();
        this.updateBars();
        this.schedule();
    }

    schedule(){
        if(this.reduceMotion) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.pick((this.active + 1) % this.steps.length), this.dwell);
    }

    pick(i){
        if(isNaN(i) || i < 0 || i >= this.steps.length) return;
        this.active = i;
        this.updateSteps();
        this.updateBars();
        if(!this.paused) this.schedule();
    }

    updateSteps(){
        this.steps.forEach((step, i) => {
            step.classList.toggle("is-done", i < this.active);
            step.classList.toggle("is-active", i === this.active);
            if(i === this.active){ step.setAttribute("aria-current", "step"); }
            else { step.removeAttribute("aria-current"); }
        });
    }

    // Barra de progreso: se reinicia relanzando la animación (no vive en state).
    updateBars(){
        this.steps.forEach((step, i) => {
            const fill = step.querySelector(".js-bar-fill");
            if(!fill) return;
            if(i === this.active && !this.reduceMotion){
                fill.style.animation = "none";
                void fill.offsetWidth;                 // fuerza reflow para reiniciar
                fill.style.animation = "a09Bar " + this.dwell + "ms linear forwards";
                fill.style.animationPlayState = this.paused ? "paused" : "running";
            }else{
                fill.style.animation = "none";
                fill.style.transform = "scaleX(0)";
            }
        });
    }

    setBarState(state){
        const step = this.steps[this.active];
        const fill = step && step.querySelector(".js-bar-fill");
        if(fill) fill.style.animationPlayState = state;
    }

    destroy(){
        clearTimeout(this.timer);
        if(this.root && this.onEnter){
            this.root.removeEventListener("pointerenter", this.onEnter);
            this.root.removeEventListener("pointerleave", this.onLeave);
        }
        if(super.destroy) super.destroy();
    }
}
